import UserLayout from "../components/UserLayout";
import Profile from "../components/user/Profile";
const ProfilePage = () => {
    return (
        <UserLayout>
            <Profile />
        </UserLayout>
    );
}

export default ProfilePage;